// Search bench: run a semantic query against one skill's knowledge base and
// inspect the chunks (with scores) the companion's search_knowledge tool would see.

import { useState } from "react";
import { searchTest } from "../../services/skills";
import type { KnowledgeSearchResult } from "../../types/skill";

export function SearchBench({ skillId }: { skillId: string | null }) {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState<KnowledgeSearchResult[] | null>(null);
  const [searching, setSearching] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function run() {
    if (!skillId || !query.trim()) return;
    setSearching(true);
    setError(null);
    try {
      setResults(await searchTest(skillId, query.trim()));
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
      setResults(null);
    } finally {
      setSearching(false);
    }
  }

  if (!skillId) {
    return <div className="state-box">Save the skill first to test search.</div>;
  }

  return (
    <div className="search-bench">
      <div className="bench-input-row">
        <input
          type="text"
          placeholder="e.g. how large should an emergency fund be"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && run()}
        />
        <button className="btn btn-primary" onClick={run} disabled={searching || !query.trim()}>
          {searching ? "…" : "Search"}
        </button>
      </div>

      {error && <div className="state-box error">{error}</div>}
      {results !== null && results.length === 0 && (
        <div className="state-box">No matches. Are the documents ingested (status ready)?</div>
      )}
      {results?.map((r, i) => (
        <div className="search-hit" key={i}>
          <div className="search-hit-head">
            <span className="mono">{r.score.toFixed(3)}</span>
            <span className="muted">
              {r.filename}
              {r.heading ? ` › ${r.heading}` : ""}
            </span>
          </div>
          <div className="search-hit-body">{r.content}</div>
        </div>
      ))}
    </div>
  );
}
